module.exports = __webpack_public_path__ + "img/buildings.73c612da.svg";